import { tokensResponseSchema } from '@varga/shared';
import { api, apiVoid } from '../lib/http';
import { type UsuarioSessao } from '../lib/session';

/** `POST /v1/auth/login` — identificador (e-mail ou login) + senha. */
export async function login(identificador: string, senha: string) {
  return api(tokensResponseSchema, '/v1/auth/login', {
    method: 'POST',
    body: { identificador, senha },
    autenticada: false,
    semRefresh: true,
  });
}

/**
 * `POST /v1/auth/primeiro-acesso` — cria a senha a partir do token do link.
 * `aceitaTermos` vem do checkbox obrigatório do portal (LGPD, UX §5.1); o painel
 * não expõe termos e mantém o default `true`.
 */
export async function primeiroAcesso(token: string, senha: string, aceitaTermos = true) {
  return api(tokensResponseSchema, '/v1/auth/primeiro-acesso', {
    method: 'POST',
    body: { token, senha, aceitaTermos },
    autenticada: false,
    semRefresh: true,
  });
}

/**
 * `POST /v1/auth/recuperar-senha` — sempre 202 com resposta neutra (não revela se
 * o identificador existe). Aceita e-mail/login (equipe) ou telefone (cliente); a
 * API resolve e bifurca o canal de entrega (e-mail vs WhatsApp) por tipo de usuário.
 */
export async function recuperarSenha(identificador: string): Promise<void> {
  await apiVoid('/v1/auth/recuperar-senha', {
    method: 'POST',
    body: { identificador },
    autenticada: false,
    semRefresh: true,
  });
}

/**
 * `POST /v1/auth/redefinir-senha` — troca a senha a partir do token do link de
 * recuperação e já loga (mesmo padrão de resposta do primeiro acesso).
 * Endpoint separado de `primeiroAcesso`: não reexige aceite de termos.
 */
export async function redefinirSenha(token: string, senha: string) {
  return api(tokensResponseSchema, '/v1/auth/redefinir-senha', {
    method: 'POST',
    body: { token, senha },
    autenticada: false,
    semRefresh: true,
  });
}

/** `POST /v1/auth/logout` — no-op 204 no servidor (refresh é stateless). */
export async function logout(): Promise<void> {
  try {
    await apiVoid('/v1/auth/logout', { method: 'POST', semRefresh: true });
  } catch {
    /* logout é client-side; ignora falha do no-op */
  }
}

export function usuarioDeResposta(r: {
  usuario: {
    id: string;
    role: UsuarioSessao['role'];
    clienteId: string | null;
    nome: string | null;
  };
}): UsuarioSessao {
  return {
    id: r.usuario.id,
    role: r.usuario.role,
    clienteId: r.usuario.clienteId,
    nome: r.usuario.nome,
  };
}
